













import { Vue, Component, Prop } from 'vue-property-decorator';
import { ExportFile } from '@/store';

@Component
export default class ExportCard extends Vue {
  @Prop({ required: true }) exportFile!: ExportFile;

  get prettifyName() {
    // To infer the name of the file from the url
    // pathname contains the export id and the file name splited by "/"
    if (this.exportFile && this.exportFile.url) {
      const url = new URL(this.exportFile.url);
      const pathnames = url.pathname.split('/');
      return pathnames[pathnames.length - 1];
    }
    return '';
  }
}
